import React, { forwardRef } from 'react';
import { Box, Grid } from "@mui/material";
import { Line } from 'react-chartjs-2';
import reportslogo from "../../assets/images/reportslogo.png";
import moment from 'moment';
import "../../assets/css/reports.css";
import "../../assets/css/assetreport.css";

const AssetReportForm = forwardRef((props, ref) => {
  const { reportdata, className } = props;
  
  const chartData = {
    labels: reportdata?.assetLifeCycleReportList?.length ? reportdata.assetLifeCycleReportList.map(item => item.year) : ['No Data'],
    datasets: [
      {
        label: 'Purchase Depreciation Value',
        data: reportdata?.assetLifeCycleReportList?.length ? reportdata.assetLifeCycleReportList.map(item => parseFloat(item.purchaseCost) || 0) : [0],
        borderColor: 'blue',
        backgroundColor: 'rgba(0, 0, 255, 0.1)',
        pointStyle: 'triangle',
        pointRadius: 5,
        fill: false,
      },
      {
        label: 'Cumulative Maintenance Cost',
        data: reportdata?.assetLifeCycleReportList?.length ? reportdata.assetLifeCycleReportList.map(item => parseFloat(item.cumulativeMaintananceValue) || 0) : [0],
        borderColor: 'red',
        backgroundColor: 'rgba(255, 0, 0, 0.1)',
        pointStyle: 'triangle',
        pointRadius: 5,
        fill: false,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Asset Life Cycle Cost Analysis',
      },
      legend: {
        position: 'bottom',
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: RM ${context.raw}`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Value (RM)',
        },
      },
      x: {
        title: {
          display: true,
          text: 'Year',
        },
      },
    },
  };

  return (
    <div id="capture" className={className} ref={ref}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '16px' }}>
        <img src={reportslogo} alt="logo" style={{ maxWidth: '100px', height: '95px', alignSelf: 'center' }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '16px' }}>
        <p style={{ marginRight: '16px', fontSize: '23px' }}>{localStorage.getItem('FacilityName')}</p>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '16px' }}>
        <p style={{ marginRight: '16px', fontSize: '28px', fontWeight: 'bold' }}>Asset Life Cycle Cost Analysis</p>
      </div>



      <table className="custom-table" style={{ width: '80%', margin: '0 auto', fontSize: '14px', border: 'none' }}>
        <tbody sx={{ fontWeight: "bold", '& td': { border: 'none' } }}>

          <tr ><td style={{ border: 'none', fontWeight: "bold", color: "black", paddingLeft: '100px', Fontsize: '18px' }}><strong>Asset No:</strong></td><td style={{ border: 'none', color: "black", paddingRight: '200px', Fontsize: '20px' }}>{reportdata.assetCode}</td></tr>
          <tr ><td style={{ border: 'none', fontWeight: "bold", color: "black", paddingLeft: '100px', Fontsize: '18px' }}><strong>Asset Description:</strong></td><td style={{ border: 'none', color: "black", paddingRight: '100px', Fontsize: '20px' }}>{reportdata.assetDesc}</td></tr>
          <tr ><td style={{ border: 'none', fontWeight: "bold", color: "black", paddingLeft: '100px', Fontsize: '18px' }}><strong>Model:</strong></td><td style={{ border: 'none', color: "black", paddingRight: '80px', Fontsize: '20px' }}>{reportdata.model}</td></tr>
          <tr ><td style={{ border: 'none', fontWeight: "bold", color: "black", paddingLeft: '100px', Fontsize: '18px' }}><strong>Serial Number:</strong></td><td style={{ border: 'none', color: "black", paddingRight: '80px', Fontsize: '20px' }}>{reportdata.serialNo}</td></tr>
          <tr ><td style={{ border: 'none', fontWeight: "bold", color: "black", paddingLeft: '100px', Fontsize: '18px' }}><strong>Equipment Life Span:</strong></td><td style={{ border: 'none', color: "black", paddingRight: '80px', Fontsize: '20px' }}>{reportdata.equipmentLifeSpan}</td></tr>
          <tr><td style={{ border: 'none', fontWeight: "bold", color: "black", paddingLeft: '100px', Fontsize: '18px' }}><strong>T&C Date:</strong></td><td style={{ border: 'none', color: "black", paddingRight: '80px', Fontsize: '20px' }}>{reportdata.tcDate ? moment(reportdata.tcDate).format('DD/MM/YY') : ''}</td></tr>
          <tr ><td style={{ border: 'none', fontWeight: "bold", color: "black", paddingLeft: '100px', Fontsize: '18px' }}><strong>Purchase Value in RM:</strong></td><td style={{ border: 'none', color: "black", paddingRight: '80px', Fontsize: '20px' }}>{reportdata.purchaseCostRM}</td></tr>
          <tr ><td style={{ border: 'none', fontWeight: "bold", color: "black", paddingLeft: '100px', Fontsize: '18px' }}><strong>Total Maintenance Cost in RM:</strong></td><td style={{ border: 'none', color: "black", paddingRight: '80px', Fontsize: '20px' }}>{reportdata.totalMaintananceValueRM}</td></tr>
          {reportdata.service === "BEMS" && (
            <><tr ><td style={{ border: 'none', fontWeight: "bold", color: "black", paddingLeft: '100px', Fontsize: '18px' }}><strong>Asset Age:</strong></td><td style={{ border: 'none', color: "black", paddingRight: '80px', Fontsize: '20px' }}>{reportdata.assetAge}</td></tr>
              <tr ><td style={{ border: 'none', fontWeight: "bold", color: "black", paddingLeft: '100px', Fontsize: '18px' }}><strong>Department:</strong></td><td style={{ border: 'none', color: "black", paddingRight: '80px', Fontsize: '20px' }}>{reportdata.department}</td></tr>
              <tr ><td style={{ border: 'none', fontWeight: "bold", color: "black", paddingLeft: '100px', Fontsize: '18px' }}><strong>Risk Percentage:</strong></td><td style={{ border: 'none', color: "black", paddingRight: '80px', Fontsize: '20px' }}>{reportdata.assetRisk}</td></tr>
              <tr ><td style={{ border: 'none', fontWeight: "bold", color: "black", paddingLeft: '100px', Fontsize: '18px' }}><strong>Risk Level:</strong></td><td style={{ border: 'none', color: "black", paddingRight: '80px', Fontsize: '20px' }}>{reportdata.assetRiskLevel}</td></tr>
              <tr ><td style={{ border: 'none', fontWeight: "bold", color: "black", paddingLeft: '100px', Fontsize: '18px' }}><strong>Asset Status / Condition:</strong></td><td style={{ border: 'none', color: "black", paddingRight: '80px', Fontsize: '20px' }}>{reportdata.assetstatus} / {reportdata.assetRiskCondition}</td></tr>
            </>)
          }
        </tbody>



      </table>


      <div className="chart-container" style={{ marginBottom: '20px', width: '80%', margin: '0 auto' }}>
        <Line data={chartData} options={options} />
      </div>

      <table border="1" style={{ width: '80%', margin: '0 auto', marginTop: '20px', textAlign: 'center', fontSize: '14px', borderCollapse: 'collapse', border: '1px solid #000' }}>
        <thead style={{ backgroundColor: '#009999' }}>
          <tr>
            <th style={{ fontWeight: "bold", color: "white" }} rowSpan={2}>Asset No</th>
            <th style={{ fontWeight: "bold", color: "white" }} rowSpan={2}>Year</th>
            <th style={{ fontWeight: "bold", color: "white" }} rowSpan={2}>Purchase Depreciation Value</th>
            <th style={{ fontWeight: "bold", color: "white" }} colSpan={2}>WorkOrder Cost(RM)</th>
            <th style={{ fontWeight: "bold", color: "white" }} rowSpan={2}>Maintenance Record Cost(RM)</th>
            <th style={{ fontWeight: "bold", color: "white" }} rowSpan={2}>PPM Contract Cost(RM)</th>
            <th style={{ fontWeight: "bold", color: "white" }} rowSpan={2}>Total Maintenance Cost(RM)</th>
            <th style={{ fontWeight: "bold", color: "white" }} rowSpan={2}>Cumulative Maintenance Cost(RM)</th>
          </tr>
          <tr>
            <th style={{ fontWeight: "bold", color: "white" }}>Scheduled</th>
            <th style={{ fontWeight: "bold", color: "white" }}>Unscheduled</th>
          </tr>
        </thead>

        <tbody>
          {reportdata?.assetLifeCycleReportList?.length ? reportdata.assetLifeCycleReportList.map((item, index) => (
            <tr key={index}>
              <td style={{ fontWeight: "bold", color: "black" }} >{reportdata?.assetCode || ''}</td>
              <td style={{ fontWeight: "bold", color: "black" }} >{item.year}</td>
              <td style={{ fontWeight: "bold", color: "black", textAlign: 'right' }} >{item.purchaseCost}</td>
              <td style={{ fontWeight: "bold", color: "black", textAlign: 'right' }} >{item.scheduledWorkOrderValue}</td>
              <td style={{ fontWeight: "bold", color: "black", textAlign: 'right' }} >{item.unScheduledWorkOrderValue}</td>
              <td style={{ fontWeight: "bold", color: "black", textAlign: 'right' }} >{item.maintanceHistory}</td>
              <td style={{ fontWeight: "bold", color: "black", textAlign: 'right' }} >{item.contract}</td>
              <td style={{ fontWeight: "bold", color: "black", textAlign: 'right' }} >{item.totalMaintananceValue}</td>
              <td style={{ fontWeight: "bold", color: "black", textAlign: 'right' }} >{item.cumulativeMaintananceValue}</td>
            </tr>
          )) : <tr><td colSpan="9" style={{ fontWeight: "bold", color: "white" }} >No data available</td></tr>}
        </tbody>
      </table>
    </div>

  );
});

export default AssetReportForm;
